import React from 'react';
import './hero.css'
import left from './../assets/2hero.png'
import right from './../assets/group1hero.png'

const Hero = () => {
    return ( <>
    <section class="hero">
    <div class="text">
    <h1 class="title">Umm Kulthum</h1>
    <p class="subtitle">The Legendary Voice of Egypt</p>
  </div>
  <img src={left} class="left-group"/>
  <img src={right} class="right-group"/>
    </section>
</> );
}
 
export default Hero;